import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';

const Flickity = themeVendor.Flickity;

export class ColumnsWithImage {
  constructor(section) {
    this.container = section.container;
    this.slider = this.container.querySelector(s.selectors$t.slider);
    this.flkty = null;
    this.gutter = 0;
    this.checkSlidesSizeOnResize = () => this.checkSlidesSize();
    this.listen();
  }

  initSlider() {
    this.slider.classList.remove(c.classes$l.carouselInactive);

    this.flkty = new Flickity(this.slider, {
      pageDots: false,
      cellAlign: 'left',
      groupCells: true,
      contain: true,
      on: {
        ready: () => {
          this.setSliderArrowsPosition(this.slider);
          setTimeout(() => {
            this.changeTabIndex();
            this.flkty.resize();
          }, 0);
        },
        change: () => {
          this.changeTabIndex();
        },
      },
    });

    Flickity.prototype._createResizeClass = function () {
      this.element.classList.add(c.classes$l.carouselResize);
    };

    Flickity.createMethods.push('_createResizeClass');

    const resize = Flickity.prototype.resize;
    Flickity.prototype.resize = function () {
      this.element.classList.remove(c.classes$l.carouselResize);
      resize.call(this);
      this.element.classList.add(c.classes$l.carouselResize);
    };
  }

  destroySlider() {
    this.slider.classList.add(c.classes$l.carouselInactive);

    if (this.flkty !== null) {
      this.flkty.destroy();
      this.flkty = null;
    }
  }

  checkSlidesSize() {
    const sliderItemStyle =
      this.container.querySelector(s.selectors$t.sliderItem).currentStyle ||
      window.getComputedStyle(this.container.querySelector(s.selectors$t.sliderItem));
    this.gutter = parseInt(sliderItemStyle.marginRight);
    const containerWidth = this.slider.offsetWidth;
    const itemsWidth = this.getItemsWidth();
    const itemsOverflowViewport = containerWidth < itemsWidth;

    if (window.innerWidth >= theme.sizes.small && itemsOverflowViewport) {
      this.initSlider();
    } else {
      this.destroySlider();
    }
  }

  changeTabIndex() {
    const selectedElementsIndex = this.flkty.selectedIndex;

    this.flkty.slides.forEach((slide, index) => {
      slide.cells.forEach((cell) => {
        cell.element.querySelectorAll(s.selectors$t.links).forEach((link) => {
          link.setAttribute(a.attributes$i.tabIndex, selectedElementsIndex === index ? '0' : '-1');
        });
      });
    });
  }

  getItemsWidth() {
    let itemsWidth = 0;
    const slides = this.slider.querySelectorAll(s.selectors$t.sliderItem);
    if (slides.length) {
      slides.forEach((item) => {
        itemsWidth += item.offsetWidth + this.gutter;
      });
    }

    return itemsWidth;
  }

  listen() {
    if (this.slider) {
      this.checkSlidesSize();
      document.addEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
    }
  }

  setSliderArrowsPosition(slider) {
    const arrows = slider.querySelectorAll(s.selectors$t.flickityButton);
    const image = slider.querySelector(s.selectors$t.sliderItemImage);

    if (arrows.length && image) {
      arrows.forEach((arrow) => {
        arrow.style.top = `${image.offsetHeight / 2}px`;
      });
    }
  }

  onBlockSelect(evt) {
    if (this.flkty !== null) {
      const index = parseInt([...evt.target.parentNode.children].indexOf(evt.target));
      const slidesPerPage = parseInt(this.flkty.slides[0].cells.length);
      const groupIndex = Math.floor(index / slidesPerPage);

      this.flkty.select(groupIndex);
    } else {
      const sliderStyle = this.slider.currentStyle || window.getComputedStyle(this.slider);
      const sliderPadding = parseInt(sliderStyle.paddingLeft);
      const blockPositionLeft = evt.target.offsetLeft - sliderPadding;

      // Native scroll to item
      this.slider.scrollTo({
        top: 0,
        left: blockPositionLeft,
        behavior: 'smooth',
      });
    }
  }

  onUnload() {
    document.removeEventListener('theme:resize:width', this.checkSlidesSizeOnResize);
  }
}